/**
 * @generated SignedSource<<75233030ab85ba580c52460467caeeb7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type VersionGroupHeader$data = {
  readonly displayName: string;
  readonly version: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "VersionGroupHeader";
};
export type VersionGroupHeader$key = {
  readonly " $data"?: VersionGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"VersionGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "VersionGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraVersion",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlVersionFieldValue"
};

(node as any).hash = "f5808a1ed0cb4468ba0571f25b813167";

export default node;
